export const BRANDING_TRANSITION_MS = 10000;
export const BRANDING_TRANSITION_FADE_SEC = 0.26;

// Applied to <body> for as long as the cover is up. See `brandingStreamBlurGlobalStyles`.
export const BRANDING_TRANSITION_BLUR_CLASS = 'myta-branding-transition-blur';

export interface IBrandingTransitionStep {
  atMs: number;
  label: string;
}

// Said as what the world is doing, not as a percentage: the hold is a fixed ten seconds rather
// than a measurement, and a bar that claimed to know how far along the re-skin is would be lying.
// The steps are spread over the whole hold — a label that stops changing halfway reads as a hang.
export const BRANDING_TRANSITION_STEPS: IBrandingTransitionStep[] = [
  { atMs: 0, label: 'Applying the configuration' },
  { atMs: 2600, label: 'Loading spots' },
  { atMs: 5200, label: 'Fetching media & assets' },
  { atMs: 7800, label: 'Dressing the map' },
];

export const BRANDING_TRANSITION_KICKER = 'Configuration';
export const BRANDING_TRANSITION_HEADLINE = 'Restyling the map';
export const BRANDING_TRANSITION_DETAIL =
  'The new configuration is going live — the world is reloading its spots, media and assets.';
export const BRANDING_TRANSITION_HINT =
  'Keep this tab open, you stay where you are.';

// What the cover says once the hold is over. Nothing tells the hub when UE has actually finished
// re-dressing the map, so the end of the ten seconds is not a completion signal and the copy does
// not claim it is — it hands the screen back rather than announcing that the work is done.
export const BRANDING_TRANSITION_DONE_STEP = 'Configuration applied';
export const BRANDING_TRANSITION_DONE_HINT =
  'A few assets may still be settling in.';
export const BRANDING_TRANSITION_DISMISS_LABEL = 'Continue';
